import { List, Text } from '@customerio/pluma-components/react';
import { AdventuresItem } from './adventures-item';
import { CONFIGS } from './rocket-configs';
import type { SetupGuide } from '@/features/setup-guide';
import { useSetupGuide } from '@/features/setup-guide/hook';

interface RocketAdventuresSelectorProps {
  setupGuide: SetupGuide | null;
  onConfigClick: (event: React.MouseEvent) => void;
}

export function RocketAdventuresSelector({ setupGuide, onConfigClick }: RocketAdventuresSelectorProps) {
  const { setupGuideQuery } = useSetupGuide();

  const configsCompletion = CONFIGS.map((config) => {
    const steps = config.steps;
    const stepsCompleted = steps.reduce((acc, step) => {
      return acc + (setupGuideQuery.data?.setup_guide?.[step.modelId] != null ? 1 : 0);
    }, 0);
    return stepsCompleted;
  });

  return (
    <List styleType="none" p="050" pb="200" px="250" gap="150" display="flex" flexDirection="column">
      {CONFIGS.map((config, index) => (
        <AdventuresItem
          key={config.id}
          configId={config.id}
          icon={config.icon}
          isComplete={setupGuide?.[config.modelId] != null}
          ariaLabel={config.title}
          onClick={onConfigClick}
          stepsCompleted={configsCompletion[index]}
        >
          <Text>{config.title}</Text>
        </AdventuresItem>
      ))}
    </List>
  );
}
